export default __webpack_public_path__ + "files/1_3_2_Draft_Bioeconomy_Strategy_Mazovia_Region_Poland.docx";